import { render, staticRenderFns } from "./columnManagement.vue?vue&type=template&id=78153879&scoped=true"
import script from "./columnManagement.vue?vue&type=script&lang=js"
export * from "./columnManagement.vue?vue&type=script&lang=js"
import style0 from "./columnManagement.vue?vue&type=style&index=0&id=78153879&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78153879",
  null
  
)

export default component.exports